"use client";

/** 生态卡片折线 / TVL 数据维度（组件已下线，类型仍被图表与详情行引用） */
export enum ChartDataType {
  DEFI_TVL = "defi-tvl",
}
